import React, { Component } from 'react';
import styles from './style.module.scss';

export default class Dropdown extends Component {
  render() {
    return <div className={styles['group']}>{this.props.children}</div>;
  }
}
